/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "azure-devops-ui/Core/Util/String", "react", "../../Resources", "../Constants", "../KubeFactory", "./PodContentReader"], function (require, exports, Util_String, React, Resources, Constants_1, KubeFactory_1, PodContentReader_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PodLog = /** @class */ (function (_super) {
        __extends(PodLog, _super);
        function PodLog(props) {
            var _this = _super.call(this, props, {}) || this;
            _this.state = { logContent: Resources.LoadingText, uid: _this.props.pod.metadata.uid };
            return _this;
        }
        PodLog.prototype.render = function () {
            return (React.createElement(PodContentReader_1.PodContentReader, { key: this.state.uid, className: "k8s-pod-log", contentClassName: "k8s-pod-log-content", options: {
                    theme: "vs-dark",
                    language: "text/plain",
                    wordWrap: "on",
                    wrappingIndent: "same"
                }, text: this.state.logContent || "" }));
        };
        PodLog.prototype.componentDidMount = function () {
            var _this = this;
            var service = KubeFactory_1.KubeFactory.getKubeService();
            var podName = this.props.pod.metadata.name;
            var spec = this.props.pod.spec || undefined;
            var podContainerName = spec && spec.containers && spec.containers.length > 0 && spec.containers[0].name || "";
            var scenarioPayload = {
                "scenario": Constants_1.Scenarios.PodLogs
            };
            service && service.getPodLog && service.getPodLog(podName, podContainerName).then(function (logContent) {
                _this.setState({
                    uid: Util_String.newGuid(),
                    logContent: logContent || ""
                });
                _this.props.markTTICallback && _this.props.markTTICallback(scenarioPayload);
            }).catch(function (error) {
                var errorMessage = error || "";
                errorMessage = (typeof errorMessage == "string") ? errorMessage : JSON.stringify(errorMessage);
                _this.setState({
                    uid: Util_String.newGuid(),
                    logContent: errorMessage
                });
                _this.props.markTTICallback && _this.props.markTTICallback(scenarioPayload);
            });
        };
        return PodLog;
    }(React.Component));
    exports.PodLog = PodLog;
});
